// utils/apiHelpers.js (या इसी Apis.js फाइल के ऊपर)
import { LogoutUser } from "./Apis";

export const handleApiErrorWithLogout = async (error, dispatch, rejectWithValue) => {
  if (error?.response?.status === 401 || error?.response?.status === 403) {
    await dispatch(LogoutUser());
  }

  // Axios Error Handling
  if (error?.response) {
    return rejectWithValue(error.response.data?.message || "Server error");
  } else if (error?.request) {
    return rejectWithValue("No response from server. Check your network.");
  } else {
    return rejectWithValue("Unexpected error occurred");
  }
};
